module.exports = __webpack_public_path__ + "static/media/Bitmap@3x.48ef013a.png";